import React from "react";
import { Tabs, Tab, Box, useMediaQuery, useTheme } from "@mui/material";
import Colors from "Constants/Color";

interface TabItem {
  label: string;
  value?: number | string;
}

interface ThemeTabsProps {
  tabs: TabItem[];
  value: number;
  onChange: (newValue: number) => void;
  className?: string;
  sx?: any;
}

const ThemeTabs: React.FC<ThemeTabsProps> = ({
  tabs,
  value,
  onChange,
  className = "",
  sx = {},
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ mt: 2, ...sx }}>
      <style>
        {`
          .theme-mui-tabs {
            min-height: 30px;
            border-bottom: 1px solid #e0e0e0 !important;
          }
          .theme-mui-tabs .MuiTabs-root {
            border-bottom: 1px solid #e0e0e0 !important;
          }
          .theme-mui-tabs .MuiTabs-indicator {
            background-color: ${Colors.themeBgColor} !important;
            height: 3px;
          }
          .theme-mui-tabs .MuiTabs-flexContainer {
            gap: 0;
          }
          .theme-mui-tabs .MuiTabs-scrollButtons {
            color: ${Colors.themeBgColor};
          }
          .theme-mui-tabs .MuiTabs-scrollButtons.Mui-disabled {
            opacity: 0.3;
          }
          .theme-mui-tabs .MuiTab-root {
            text-transform: none;
            font-family: 'Poppins', sans-serif !important;
            font-size: 0.8rem;
            font-weight: 500;
            min-height: 30px;
            padding: 8px 14px;
            color: #000;
            margin-bottom: 0;
            white-space: nowrap;
          }
          .theme-mui-tabs .MuiTab-root.Mui-selected {
            color: ${Colors.themeBgColor} !important;
            font-weight: 600;
          }
          .theme-mui-tabs .MuiTab-root:hover {
            color: ${Colors.themeBgColor} !important;
            background-color: rgba(57, 105, 231, 0.04);
          }
          
          /* Responsive styles for mobile */
          @media (max-width: 600px) {
            .theme-mui-tabs .MuiTab-root {
              font-size: 0.75rem;
              padding: 6px 10px;
              min-height: 28px;
            }
          }
          
          /* Responsive styles for tablet */
          @media (max-width: 960px) and (min-width: 601px) {
            .theme-mui-tabs .MuiTab-root {
              font-size: 0.775rem;
              padding: 7px 12px;
            }
          }
        `}
      </style>
      <Tabs
        className={`theme-mui-tabs ${className}`}
        value={value}
        onChange={(event, newValue) => onChange(newValue)}
        variant={isMobile || isTablet ? "scrollable" : "standard"}
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>
    </Box>
  );
};

export default ThemeTabs;

